import { Link } from "react-router-dom";
import React from "react";
import "../styles/DigitalMarketing.css";
import dig1 from "../assets/services/digital 1.jpeg";
import dig2 from "../assets/services/dig 2.jpeg";

const solutions = [
  {
    title: "Search Engine Optimization",
    description:
      "Improve your online visibility and help your website reach the right audience through practical SEO strategies.",
  },
  {
    title: "Social Media Marketing",
    description:
      "Build meaningful social presence through creative content, audience engagement and consistent communication.",
  },
  {
    title: "Content Strategy",
    description:
      "Create useful and engaging content that communicates your brand clearly and connects with your audience.",
  },
  {
    title: "Performance Marketing",
    description:
      "Plan and manage digital campaigns focused on reaching relevant audiences and supporting measurable business goals.",
  },
  {
    title: "Branding & Creative",
    description:
      "Develop consistent visual and creative communication that helps your brand stand out across digital platforms.",
  },
  {
    title: "Analytics & Insights",
    description:
      "Understand digital performance through useful data, reporting and insights that support better decisions.",
  },
];

const process = [
  {
    title: "Research",
    description:
      "Understand your audience, competitors, market and current digital presence before planning the strategy.",
  },
  {
    title: "Strategy",
    description:
      "Create a practical digital marketing plan around your business objectives and target audience.",
  },
  {
    title: "Launch",
    description:
      "Bring campaigns, content and creative communication to the right digital channels.",
  },
  {
    title: "Optimize",
    description:
      "Review performance and continuously improve campaigns, content and audience engagement.",
  },
];

function DigitalMarketing() {
  return (
    <main className="digital-page">

      <section className="digital-hero">
        <div className="digital-hero-content">
          <span className="digital-eyebrow">
            DIGITAL MARKETING
          </span>

          <h1>
            Make Your Brand
            <span> More Visible</span>
          </h1>

          <p>
            Connect your brand with the right audience through
            thoughtful digital strategies, creative content and
            measurable marketing solutions.
          </p>

          <a href="#digital-solutions" className="digital-primary-btn">
            Explore Marketing Solutions
            <span>→</span>
          </a>
        </div>

        <div className="digital-hero-visual">
          <div className="digital-hero-image">
            <img
              src={dig1}
              alt="Digital marketing analytics"
            />
          </div>
        </div>
      </section>

      <section className="digital-intro">
        <div className="digital-intro-header">
          <div className="digital-intro-label">
            <span>01</span>
            <p>WHAT WE CREATE</p>
          </div>

          <div className="digital-intro-heading">
            <h2>
              Marketing that connects
              <span> people with your brand</span>
            </h2>

            <p>
              From SEO and social media to content, advertising
              and analytics, we create digital marketing strategies
              designed around your audience and business goals.
            </p>
          </div>
        </div>

        <div className="digital-intro-content">
          <div className="digital-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              Good marketing starts with
              <strong> understanding your audience</strong>
            </h3>

            <p>
              We combine research, creativity and digital strategy
              to create marketing experiences that communicate
              clearly and support meaningful business growth.
            </p>
          </div>

          <div className="digital-intro-points">
            <div className="digital-intro-point">
              <span>01</span>
              <div>
                <h4>Audience focused</h4>
                <p>
                  Understand the people you want to reach and
                  create communication around their needs.
                </p>
              </div>
            </div>

            <div className="digital-intro-point">
              <span>02</span>
              <div>
                <h4>Creative communication</h4>
                <p>
                  Combine strong visuals, useful content and
                  consistent messaging to build your brand.
                </p>
              </div>
            </div>

            <div className="digital-intro-point">
              <span>03</span>
              <div>
                <h4>Data informed</h4>
                <p>
                  Use campaign performance and digital insights
                  to continuously improve your marketing efforts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="digital-solutions"
        id="digital-solutions"
      >
        <div className="digital-section-heading">
          <div>
            <span className="digital-small-label">
              MARKETING SERVICES
            </span>

            <h2>
              Explore our
              <span> digital solutions</span>
            </h2>
          </div>

          <p>
            Digital marketing services that help your business
            become more visible, relevant and connected online.
          </p>
        </div>

        <div className="digital-solutions-grid">
          {solutions.map((item) => (
            <article
              className="digital-solution-card"
              key={item.title}
            >
              <div className="digital-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="digital-tech-section">
        <div className="digital-tech-content">
          <span className="digital-small-label">
            DIGITAL GROWTH
          </span>

          <h2>
            From visibility
            <span> to meaningful engagement</span>
          </h2>

          <p>
            Digital marketing is more than simply being visible.
            We help brands create useful experiences that attract
            the right audience and encourage meaningful engagement.
          </p>

          <div className="digital-tech-points">
            <div>
              <strong>01</strong>
              <h4>Stronger visibility</h4>
              <p>
                Improve your presence across search engines,
                social platforms and digital channels.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Better engagement</h4>
              <p>
                Create relevant content and communication that
                keeps your audience connected to your brand.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Measurable growth</h4>
              <p>
                Understand results through analytics and improve
                your digital activities over time.
              </p>
            </div>
          </div>
        </div>

        <div className="digital-tech-visual">
          <div className="digital-tech-image">
            <img
              src={dig2}
              alt="Digital marketing strategy"
            />
          </div>
        </div>
      </section>

      <section className="digital-process">
        <div className="digital-process-heading">
          <span className="digital-small-label">
            HOW WE WORK
          </span>

          <h2>
            From strategy
            <span> to digital growth</span>
          </h2>

          <p>
            A structured marketing process helps us create
            campaigns that are clear, creative and continuously
            improving.
          </p>
        </div>

        <div className="digital-process-grid">
          {process.map((item, index) => (
            <article
              className="digital-process-item"
              key={item.title}
            >
              <div className="digital-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="digital-final">
        <div className="digital-final-content">
          <div className="digital-final-main">
            <div className="digital-final-label">
              <span></span>
              GROW YOUR DIGITAL PRESENCE
            </div>

            <h2>
              Give your brand
              <span> more room to grow</span>
            </h2>

            <p>
              Tell us about your brand, audience or marketing
              goals. We can help you explore practical digital
              strategies for your business.
            </p>
          </div>

          <div className="digital-final-action">
            <div className="digital-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>
              <p>Marketing · Creative · Growth</p>
            </div>

            <Link
              to="/contact"
              className="digital-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default DigitalMarketing;